import { useState } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import ReactDatePicker from 'react-datepicker';
import { FormFieldDatePickerRoot } from '@components/core-ui/form-elements/FormFieldDatePickerRoot';
import { ScriberDashboardDeadlineCalendarDayDto, ScriberDashboardJobDto } from 'app/API';

const getExcludeDates = (currentDate = new Date(), initDates: ScriberDashboardDeadlineCalendarDayDto[]): Date[] => {
  const endOfThisMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 10);
  let iterableDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const dates: Date[] = [];
  while (iterableDate.getTime() < endOfThisMonth.getTime()) {
    if (!initDates.find((date: ScriberDashboardDeadlineCalendarDayDto) => date.date === getDateYMD(iterableDate))) {
      dates.push(new Date(iterableDate));
    }
    iterableDate = new Date(iterableDate.getFullYear(), iterableDate.getMonth(), iterableDate.getDate() + 1);
  }
  return dates;
};

const getDateYMD = (date: Date | string | undefined) => {
  const d = new Date(date ?? 0);
  const month = d.getMonth() + 1 > 9 ? d.getMonth() + 1 : `0${d.getMonth() + 1}`;
  const day = d.getDate() > 9 ? d.getDate() : `0${d.getDate()}`;
  return `${month}-${day}-${d.getFullYear()}`;
};

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

type TProps = {
  calendar: ScriberDashboardDeadlineCalendarDayDto[];
};

export const DeadlineCalendar = ({ calendar = [] }: TProps) => {
  const [currentDate, setCurrentDate] = useState<Date | undefined>(new Date());
  const excludeDates = getExcludeDates(currentDate, calendar);
  const currentDateInfo = calendar.find((date) => date.date === getDateYMD(currentDate));
  let currentDateJobs: ScriberDashboardJobDto[] = [];
  if (currentDateInfo) {
    currentDateJobs = currentDateInfo.jobs;
  }
  const startOfThisMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  const endOfThisMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1);
  const dateFormat = 'MM/dd/yyyy';

  return (
    <>
      <FormFieldDatePickerRoot>
        <div className="deadline-calendar pt-5 pb-3">
          <ReactDatePicker
            dateFormat={dateFormat}
            minDate={startOfThisMonth}
            maxDate={endOfThisMonth}
            excludeDates={excludeDates}
            renderCustomHeader={({ date }) => (
              <div className="flex justify-center">
                {/* <StyledControlIcon icon={leftIcon} onClick={decreaseMonth} />*/}
                <span className="text-sm font-medium leading-[34px] text-title">{months[date.getMonth()]}</span>
                {/* <StyledControlIcon icon={rightIcon} onClick={increaseMonth} />*/}
              </div>
            )}
            selected={currentDate}
            onChange={(date: Date | null) => setCurrentDate(date ?? new Date())}
            disabledKeyboardNavigation
            inline
          />
        </div>
      </FormFieldDatePickerRoot>

      <div className="mr-[-20px]">
        {!currentDateJobs.length ? (
          <div className="text-xs font-semibold leading-none text-foreground-muted text-center py-[5px] pb-2.5">
            No Jobs on this date
          </div>
        ) : null}
        {currentDateJobs.length ? (
          <Scrollbars autoHeight autoHeightMin={30} autoHeightMax={320}>
            <div className="pr-5">
              {currentDateJobs.map((cdj: ScriberDashboardJobDto) => {
                const assignee = cdj.assignee ? `${cdj.assignee.name} ${cdj.assignee.lastname}` : 'Job is not assigned';
                return (
                  <div
                    className="pb-[15px] mb-[15px] border-b border-divider last:mb-0 last:pb-[5px] last:border-b-0"
                    key={cdj.id}
                  >
                    <div className="text-xs font-semibold leading-none text-foreground-muted whitespace-nowrap overflow-hidden text-ellipsis">
                      {cdj.name}
                    </div>
                    <div className="text-xs font-normal leading-[150%] text-foreground-muted whitespace-nowrap overflow-hidden text-ellipsis">
                      {assignee}
                    </div>
                  </div>
                );
              })}
            </div>
          </Scrollbars>
        ) : null}
      </div>
    </>
  );
};
